/* eslint-disable camelcase */
import { Controller } from '@hotwired/stimulus'

import { validatePostcode } from '../services/address'
import { track, trackSegment } from '../utils/track'
import { isValidPostcode, formatPostcode } from 'utils/postcode'
import uuidv1 from 'uuid/v1'
import { addressEntryForm } from 'utils/tracking-constants'

export default class PostcodeFormController extends Controller {
  static targets = ['form', 'input', 'error']

  connect() {
    this.formId = uuidv1()
    this.formName = this.formTarget.dataset.trackingId

    this.landingFormProps = addressEntryForm({
      formId: this.formName,
      formName: this.formName,
      formStartedId: this.formId
    })

    trackSegment('Form Loaded', {
      ...this.landingFormProps
    })
  }

  submit(event) {
    const error = !isValidPostcode(this.inputTarget.value)

    if (error) {
      track('Broadband - Postcode Capture', 'Incorrect Postcode')
      this.errorTarget.style.display = 'block'
      trackSegment('Form Errored', {
        submit_id: this.formId,
        form_name: this.formName,
        form_started_id: this.formId,
        form_error_text: 'Please try re-entering your postcode in the correct format e.g. SE1 2LH'
      })
      event.preventDefault()
      return false
    }

    trackSegment('Form Submitted', {
      ...this.landingFormProps,
      form_step_field: [
        {
          id: 'postcode-input',
          label: '',
          value: this.inputTarget.value,
          type: 'text'
        }
      ]
    })
  }

  changeValue() {
    track('Broadband - Postcode Capture', 'Change Postcode')

    // TODO: Move this to other controller
    validatePostcode(this.inputTarget.value)

    this.inputTarget.value = formatPostcode(this.inputTarget.value)
  }
}
